/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { useMutation } from '@tanstack/react-query'
import type { UseMutationOptions } from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { campaignUsageRequestMore } from '../../axios/campaignUsageRequestMore'
import type {
	CampaignUsageRequestMoreError,
	CampaignUsageRequestMorePathParams,
	CampaignUsageRequestMoreRequest,
	CampaignUsageRequestMoreResponse,
} from '../../types/CampaignUsageRequestMore'

export const campaignUsageRequestMoreMutationKey = () =>
	[{ url: '/:organisation/campaign-usage/request-more' }] as const

export type CampaignUsageRequestMoreMutationKey = ReturnType<typeof campaignUsageRequestMoreMutationKey>

export type CampaignUsageRequestMoreVariables = {
	organisation: CampaignUsageRequestMorePathParams['organisation']
	data: CampaignUsageRequestMoreRequest
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CampaignUsageController.php CampaignUsageController::requestMore */
export function useCampaignUsageRequestMore<TContext = unknown>(
	options?: UseMutationOptions<
		CampaignUsageRequestMoreResponse,
		AxiosError<CampaignUsageRequestMoreError>,
		CampaignUsageRequestMoreVariables,
		TContext
	>,
	config?: AxiosRequestConfig,
) {
	return useMutation({
		mutationKey: campaignUsageRequestMoreMutationKey(),
		mutationFn: ({ organisation, data }: CampaignUsageRequestMoreVariables) =>
			campaignUsageRequestMore(organisation, data, config).then(res => res.data),
		...options,
	})
}
